module.exports = __webpack_public_path__ + "static/media/bone.7cb07ab1.svg";